// Please avoid using this component
// This is a solution when the CSS sticky position is not fully working.
// If you can use the native browser API use it. This is just for special cases where the sticky position is not fully working.
// This componet is only for sticky bottom 0px. If we want other effect we need to write more logic
// If you found a better solution, refactor and delete this one

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { StickyWrapper } from './Sticky.styled';

let startFlag = null;
let breakingPoint = null;

export default function Sticky(props) {
  const { children } = props;

  const [visible, setVisible] = useState(true);

  const nonStickyRef = React.createRef();
  const scrollHandler = () => {
    if (nonStickyRef && nonStickyRef?.current && startFlag === null) {
      startFlag = true;
    }
    if (
      nonStickyRef &&
      nonStickyRef?.current &&
      startFlag !== null &&
      breakingPoint === null
    ) {
      if (
        nonStickyRef.current.getBoundingClientRect().bottom -
          window.screen.availHeight <=
        0
      ) {
        breakingPoint = window.scrollY;
      }
    }
    if (breakingPoint !== null) {
      setVisible(window.scrollY <= breakingPoint);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', scrollHandler, true);
    return () => {
      window.removeEventListener('scroll', scrollHandler, true);
    };
  }, []);

  return (
    <>
      <div ref={nonStickyRef}>{children}</div>
      <StickyWrapper visible={visible}>{children}</StickyWrapper>
    </>
  );
}

Sticky.propTypes = {
  children: PropTypes.node,
};
